/**
 * WaveIntroScreen - Displays wave number before gameplay begins
 * Shows for 2-3 seconds with animation, then transitions to playing state.
 */

export class WaveIntroScreen {
  constructor(game) {
    this.game = game;
    this.wave = 1;
    this.timer = 0;
    this.duration = 2.5; // seconds
    this.playingState = null;
  }

  enter(data = {}) {
    this.wave = data.wave || 1;
    this.timer = 0;
    this.playingState = data.playingState || null;

    // Update overlay for testing
    this._updateOverlay();
  }

  exit() {
    if (this.game.uiOverlay) {
      this.game.uiOverlay.innerHTML = '';
    }
  }

  _updateOverlay() {
    if (!this.game.uiOverlay) return;

    this.game.uiOverlay.innerHTML = `
      <div data-screen="waveIntro">
        <div class="wave-number" data-wave="${this.wave}">Wave ${this.wave}</div>
        <div class="wave-subtitle">DEFEND YOUR CITIES</div>
      </div>
    `;
  }

  update(dt) {
    this.timer += dt;
    if (this.timer >= this.duration) {
      // Transition back to playing state with _resuming flag
      this.game.state.setState('playing', { _resuming: true });
    }
  }

  render(ctx) {
    const w = this.game.width;
    const h = this.game.height;

    this.game.renderer.clearBackground();

    // Wave number with animated scale
    const progress = Math.min(this.timer / this.duration, 1);
    const scale = 1 + Math.sin(progress * Math.PI) * 0.2;
    const fontSize = Math.max(40, w * 0.06) * scale;

    this.game.renderer.drawGlowText(`WAVE ${this.wave}`, w / 2, h / 2, {
      font: `${fontSize}px "Share Tech Mono", monospace`,
      color: '#ffffff',
      glowColor: '#00ff88',
      glowSize: 25,
    });

    // Subtitle
    if (this.timer > 0.5) {
      this.game.renderer.drawGlowText('DEFEND YOUR CITIES', w / 2, h * 0.6, {
        font: `${Math.max(16, w * 0.02)}px "Share Tech Mono", monospace`,
        color: '#aabbcc',
        glowColor: '#445566',
        glowSize: 5,
      });
    }
  }
}
